var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationfailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_15017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_324_15017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_324_15017",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 164
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 0H0V164H164V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_324_15017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_324_15017",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -64,
    y: 0,
    width: 292,
    height: 164
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-63.7812 0H227.774V164H-63.7812V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_324_15017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_324_15017",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -74,
    y: -19,
    width: 312,
    height: 202
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.5078 21.8242L214.399 -18.9058L237.497 142.177L-50.4095 182.907L-73.5078 21.8242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_324_15017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.5093 132.165C60.4668 133.277 35.2395 112.38 30.9363 83.645L26.3915 53.2974C40.7263 52.945 54.0979 45.9958 62.6241 34.467L63.3331 33.5083L85.6351 30.1628L86.5938 30.8714C98.1226 39.3918 112.942 42.1122 126.75 38.243L131.295 68.5906C135.598 97.3252 117.601 124.707 89.5093 132.165Z",
    stroke: "#D00026",
    strokeWidth: 10.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.458 77.315C83.51 79.9489 80.4733 84.055 78.5253 86.6889",
    stroke: "#D00026",
    strokeWidth: 10.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6787 85.4659C84.0447 83.5193 79.9386 80.4846 77.3047 78.538",
    stroke: "#D00026",
    strokeWidth: 10.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.084 78.2363C109.159 92.0889 99.6074 105.004 85.7507 107.082C71.894 109.161 58.9792 99.6161 56.9047 85.7635C54.8302 71.9109 64.3815 58.9961 78.2382 56.9175C92.0948 54.839 105.01 64.3837 107.084 78.2363Z",
    stroke: "#D00026",
    strokeWidth: 10.2083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_15017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_324_15017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationfailed);
export default __webpack_public_path__ + "static/media/validationfailed.e478b805b4875e173e0413e4f5d0e204.svg";
export { ForwardRef as ReactComponent };